import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchPropertyForSale } from "./thunk";

// User type
export interface User {
    _id: string;
    name: string;
    mobileNumber: string;
}

// Area type
export interface Area {
    state: string;
    city: string;
    area: string;
    isActive: boolean;
}

// Property type
export interface PropertyType {
    _id: string;
    propertyType: string;
    isActive: boolean;
}

// Location type
export interface Location {
    address: string;
    lat: number;
    lng: number;
}

// Main Property Listing type
export interface Property {
    _id: string;
    userId: User;
    remarks: string;
    area: Area;
    areaSqFt: string;
    city: string;
    propertyType: PropertyType;
    state: string;
    surveyNumber: string;
    marketRate: string;
    location: Location;
    photos: string[];
    isApproved: boolean;
    isActive: boolean;
    isDeleted: boolean;
    createdAt: string;
}


export type paginationType = {
    totalCount: number,
    page: number
    pageSize: number
}

export type FilterType = {
    isActive: boolean | null
    state: string,
    city: string,
    search: string;
    sortBy: any,
    sortOrder: any,
    totalCount: number,
    page: number,
    limit: number
}

type InitialState = {
    propertySaleList: any
    filterData: FilterType,
    paginationData: paginationType
};

const initialState: InitialState = {
    propertySaleList: [],
    filterData: {
        isActive: null,
        state: "",
        city: "",
        search: "",
        sortBy: "",
        sortOrder: null,
        totalCount: 0,
        page: 1,
        limit: 50,
    },
    paginationData: {
        totalCount: 0,
        page: 1,
        pageSize: 50
    },

};

const propertiesForSaleSlice = createSlice({
    name: "propertiesForSale",
    initialState,
    reducers: {
        setFilterData(state, action) {
            state.filterData = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPropertyForSale.pending, (state) => {
            })
            .addCase(fetchPropertyForSale.fulfilled, (state, action) => {
                state.propertySaleList = action.payload.data;
                state.filterData = {
                    ...state.filterData,
                    ...action.payload.filterData,
                };
            })
            .addCase(fetchPropertyForSale.rejected, (state, action) => {
            });
    },
});

export const {setFilterData } = propertiesForSaleSlice.actions;
export default propertiesForSaleSlice.reducer;
